import academicPositionsSlice from "@pages/HR/AcademicPositions/store/academicPositionsSlice";
import scientificTitleSlice from "@pages/HR/Employees/EmployeesSettingsPages/ScientificTitle/store/scientificTitleSlice";
import scientificDegreeSlice from "@pages/HR/Employees/EmployeesSettingsPages/ScientificDegree/store/scientificDegreeSlice";
import employeesSlice from "@pages/HR/Employees/store/employeesSlice";
import positionsHoursSlice from "@pages/HR/PositionsWorkingHours/store/positionsHoursSlice";
import associationsSlice from "@pages/HR/RolesAssociations/store/associationsSlice";

export const hrReducer = {
    academicPositions: academicPositionsSlice.reducer,
    scientificTitle: scientificTitleSlice.reducer,
    scientificDegree: scientificDegreeSlice.reducer,
    employees: employeesSlice.reducer,
    positionsHours: positionsHoursSlice.reducer,
    associations: associationsSlice.reducer,
};
